export const getData = (endpoint: string) =>
  fetch(process.env.REACT_APP_CMS_BASE_URL + endpoint).then(response => response.json());
